// useOnlineStatus.ts — yhteyden tila navigator.onLine-API:n kautta.
//
// Käyttö:
//   const isOnline = useOnlineStatus();
//
// HUOM: navigator.onLine on epäluotettava — selain raportoi true jos
// verkkokortti on aktiivinen, vaikka itse internet-yhteys olisi katkennut
// (kahvilan WiFi joka ei reititä mihinkään). Vaiheessa 3 (mutation queue)
// lisätään failuren-pohjainen detektointi: jos POST/PUT epäonnistuu network
// errorilla, asetamme tilan offlineen vaikka navigator.onLine sanoisi muuta.

import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return isOnline;
}
